import { useLocation, useNavigate } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { useMessengerUnreadCount } from '@/hooks/api/useMessenger';

export function MessengerFab(): JSX.Element | null {
  const location = useLocation();
  const navigate = useNavigate();
  const { data: unread } = useMessengerUnreadCount();
  const count = unread?.count ?? 0;

  if (location.pathname.startsWith('/messenger')) return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/messenger')}
      // Hidden while a table's selection bar is up — they share the bottom-right corner
      // (`[data-bulk-actions-bar]` in index.css).
      data-messenger-fab=""
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full shadow-[var(--shadow-overlay)] flex items-center justify-center transition-transform hover:scale-105 active:scale-95"
      style={{ backgroundColor: 'var(--color-primary-500)' }}
      aria-label="Мессенджер"
    >
      <MessageSquare className="w-6 h-6 text-white" />
      {count > 0 && (
        <span className="absolute -top-1 -right-1 min-w-5 h-5 px-1.5 rounded-full bg-[var(--color-error)] text-white text-xs font-medium flex items-center justify-center">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
}
